import { DeleteAccount } from '../components/DeleteAccount';
import { SignInPanel } from '../components/SignInPanel';
import { sessionLoading, user } from '../state/session';

/**
 * The standalone deletion page at /delete-account.
 *
 * Play requires a deletion route that someone can reach from a browser after uninstalling the
 * app, and that states what is removed and what is kept — hence a page rather than only the
 * section inside Settings.
 */
export function DeleteAccountPage() {
  return (
    <div class="view">
      <header class="view__header">
        <h1>Delete your Podcastie account</h1>
      </header>

      <section class="section">
        <p class="muted">
          Deleting your account immediately and permanently removes your sign-in details and any
          passkeys, your subscriptions, your queue and playlists, and your listening history and
          positions. Nothing is retained afterwards, and there is no recovery period.
        </p>
        <p class="muted">
          Podcast feeds and episodes themselves stay in the shared library, because they are
          public data that other listeners subscribe to. They contain nothing personal to you.
        </p>
        <p class="muted">
          For what is stored in the first place, see the <a href="/privacy">privacy policy</a>.
        </p>
      </section>

      {sessionLoading.value ? (
        <p class="muted">Loading…</p>
      ) : user.value ? (
        <DeleteAccount />
      ) : (
        <section class="section">
          <h2 class="section__title">Sign in to continue</h2>
          <p class="muted">
            Deletion has to be confirmed from the account itself, so sign in first. You will be
            brought straight back here.
          </p>
          <SignInPanel />
        </section>
      )}
    </div>
  );
}
